// Utility functions for Results component

export const getSeverityColor = (severity) => {
  const colors = {
    'critical': 'red',
    'high': 'orange',
    'medium': 'yellow',
    'low': 'green',
    'info': 'blue',
    'none': 'neutral'
  };
  return colors[severity] || 'neutral';
};

export const getSeverityBackgroundColor = (severity) => {
  const colors = {
    'critical': '#FEE2E2',
    'high': '#FEE2E2',
    'medium': '#FEF3C7',
    'low': '#DBEAFE',
    'info': '#E0E7FF',
    'none': '#F3F4F6'
  };
  return colors[severity] || '#F3F4F6';
};

export const getSeverityTextColor = (severity) => {
  const colors = {
    'critical': '#991B1B',
    'high': '#991B1B',
    'medium': '#92400E',
    'low': '#1E40AF',
    'info': '#3730A3',
    'none': '#374151'
  };
  return colors[severity] || '#374151';
};

export const getSecondLevelDomain = (domainName) => {
  const parts = domainName.split('.');
  if (parts.length >= 2) {
    return parts.slice(-2).join('.');
  }
  return domainName;
};

export const groupDomainsBySecondLevel = (domains) => {
  if (!Array.isArray(domains) || domains.length === 0) {
    return {};
  }
  
  const groups = {};
  domains.forEach(domain => {
    if (domain && domain.name) {
      const secondLevel = getSecondLevelDomain(domain.name);
      if (!groups[secondLevel]) {
        groups[secondLevel] = [];
      }
      groups[secondLevel].push(domain);
    }
  });
  
  return Object.keys(groups)
    .sort()
    .reduce((sortedGroups, key) => {
      sortedGroups[key] = groups[key].sort((a, b) => a.name.localeCompare(b.name));
      return sortedGroups;
    }, {});
};

export const highlightSearchTerm = (text, searchTerm) => {
  if (!searchTerm || !text) return text;
  
  const regex = new RegExp(`(${searchTerm})`, 'gi');
  const parts = text.toString().split(regex);
  
  return parts.map((part, index) => 
    regex.test(part) ? (
      <span key={index} style={{ backgroundColor: '#FFE8E6', fontWeight: 'bold' }}>
        {part}
      </span>
    ) : part
  );
};

